import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Login from '../pages/Auth/Login';
import Register from '../pages/Auth/Register';
import ForgotPassword from '../pages/Auth/ForgotPassword';
import NotFound from '../pages/NotFound/NotFound';

const AuthRouter = () => {
    return (
        <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            {/*<Route path="*" element={<NotFound />} />*/}
            <Route path="*" element={<Login />} />
        </Routes>
    );
};

export default AuthRouter;
